import { CoreApi } from '@inter-ikea-storageone/range';
import { MessageDescriptor } from 'react-intl';
import { PrimitiveType } from 'intl-messageformat';
import { capitalizeFirstLetter } from 'products/utils';

export const getMenuTitle = (
  title: string | ((coreApi: CoreApi) => string) | undefined,
  titleValue: Record<string, PrimitiveType> | undefined,
  formatMessage: (
    descriptor: MessageDescriptor,
    values?: Record<string, PrimitiveType> | undefined
  ) => string,
  coreApi: CoreApi
): string => {
  if (!title || title === '') {
    return '';
  } else if (typeof title === 'string') {
    return capitalizeFirstLetter(formatMessage({ id: title }, titleValue));
  } else {
    const titleId = title(coreApi);
    return titleId !== '' ? capitalizeFirstLetter(formatMessage({ id: titleId }, titleValue)) : '';
  }
};
